import { useEffect, useCallback } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate, Outlet, useParams } from "react-router-dom";
import { Frame, TopBar, Text } from "@shopify/polaris";
import { ExitIcon } from "@shopify/polaris-icons";
import { useTranslation } from "react-i18next";
import Modalx from "components/modalx/modalx";
import { logout, toogleUserMenu } from "../../containers/auth/authSlice";
import "./styles.scss";

function AppLayout() {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { companyId } = useParams();
  // const { session, userMenuActive } = useSelector((state) => state.authReducer);

  // const handleLogout = useCallback(async () => {
  //   await dispatch(logout());
  //   navigate("/auth/login");
  // }, [dispatch, navigate]);

  // const handleToggleUserMenu = useCallback(() => {
  //   dispatch(toogleUserMenu());
  // }, [dispatch]);

  // const userMenuActions = [
  //   {
  //     items: [
  //       {
  //         content: t("log_out"),
  //         icon: ExitIcon,
  //         onAction: handleLogout,
  //       },
  //     ],
  //   },
  // ];

  // const userMenuMarkup = session ? (
  //   <TopBar.UserMenu
  //     actions={userMenuActions}
  //     name={session.email || `${session.name_user} ${session.surname_user}` || session.session_id}
  //     detail={session.position || session.title_position}
  //     open={userMenuActive}
  //     onToggle={handleToggleUserMenu}
  //   />
  // ) : null;

  const Logo = (
    <div className="logo_text" style={{color: "#fff", height: "100%", width: "100%" ,cursor:'pointer'}} 
    onClick={()=> navigate("/app")}
    >
      <Text as="h1" fontWeight="semibold">
        {"UHB Group"}
      </Text>
    </div>
  );

  const topBarMarkup = (
    <div className="company_select_box">
      <TopBar
        logoSuffix={Logo}
        // userMenu={userMenuMarkup}
      />
    </div>
  );

  if (companyId) {
    return <Outlet />;
  } else {
    return (
      <div className="main_content">
        <Frame
          topBar={topBarMarkup}
          // onNavigationDismiss={handleNavigationToggle}
          logo={Logo}
        >
          <Outlet />
          <Modalx />
        </Frame>
      </div>
    );
  }
}

export default AppLayout;
